/**
 * EmptyTabState — placeholder shown when a DevTools tab is in whitelist
 * (empty) mode with no whitelisted features. Extracted from DevToolsPanel
 * during the decomposition; behavior-preserving.
 */
import React from 'react';
import { getWhitelist, type DevToolsTabId } from './DevTools.config';
import {
  emptyStateStyle,
  emptyStateIconStyle,
  emptyStateTitleStyle,
  emptyStateLabelStyle,
  emptyStateWhitelistStyle,
  emptyStateHintStyle,
} from './devToolsPanelStyles';

interface EmptyTabStateProps {
  tabName: string;
  tabId: string;
}

export const EmptyTabState: React.FC<EmptyTabStateProps> = ({ tabName, tabId }) => {
  const whitelist = getWhitelist(tabId as DevToolsTabId);

  return (
    <div style={emptyStateStyle}>
      <div style={emptyStateIconStyle}>📭</div>
      <div style={emptyStateTitleStyle}>
        {tabName} Tab - Empty Mode
      </div>
      {whitelist.length > 0 ? (
        <>
          <div style={emptyStateLabelStyle}>
            Showing only whitelisted features:
          </div>
          <div style={emptyStateWhitelistStyle}>
            {whitelist.join(', ')}
          </div>
        </>
      ) : (
        <div style={emptyStateHintStyle}>
          No features whitelisted.<br/>
          Run: whitelistFeature(&quot;{tabId}&quot;, &quot;featureName&quot;)
        </div>
      )}
    </div>
  );
};
